import { apiWithPrefix as api } from '../utils/api';
const WorkScheduleService = {
  rules: () => api.get('/work-schedule/rules').then(r => r.data),
  calendar: (from, to, email) => api.get('/work-schedule/calendar', { params: { from, to, email } }).then(r => r.data),
  preview: body => api.post('/work-schedule/preview', body).then(r => r.data),
  baseline: body => api.post('/work-schedule/baseline', body).then(r => r.data),
  save: body => api.post('/work-schedule/rules', body).then(r => r.data),
  leaveDays: body => api.post('/work-schedule/leave-days', body).then(r => r.data),
  today: () => api.get('/work-schedule/today').then(r => r.data),
  punch: action => api.post('/work-schedule/punch', { action }).then(r => r.data),
  review: (id, payment) => api.post(`/work-schedule/reviews/${id}`, { payment }).then(r => r.data),
};
export default WorkScheduleService;
